import { Component, OnInit } from '@angular/core';
import { LicenseDataService } from '../../services/LicenseData.service';
import { AdminData } from '../../models/AdminData.model';
import { FormModel } from '../../models/Form.model';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { PaymentInvoiceModal } from '../../models/PaymentInvoice.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { EProductType } from '../../EProductType.enum';
import { PaypalProductModal } from '../../../Paypal/models/PaypalProduct.model';
import { ErrorModel } from '../../../../shared/models/Error.model';

declare var $: any;
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})

export class AdminComponent implements OnInit {
  allow: boolean = false;
  searchTerm: string;
  showMail: boolean = false;
  users: AdminData[];
  userAddPayment: AdminData;
  showMailLoad: boolean = false;
  validDaysReadOnly: boolean = false;
  userResendMail: AdminData;
  paymentAgainstInvoice: PaymentInvoiceModal;
  pendingPayment: any;
  mailIdToResend: string = '';
  userModel: FormModel;
  priceRate: number = 0;
  qrInfo: any;
  prodTypee: string;
  adminDetailData: AdminData;
  emailId: string;
  credentialData: any;
  typeLicense;
  showAddPayment: boolean = false;
  licenseNum;
  validDays;
  validDevices;
  isUsed: boolean = false;
  clicked: boolean = false;
  allProducts: PaypalProductModal[] = [];
  emailIsValid: boolean;
  emailReturn: any;
  modelForChecking: AdminData;
  emailProcessing: boolean;
  routingPath: string = '';
  showbackDash: boolean = false;
  adminHaCount: number = 0;
  sButton: string = 'Save';
  currentPage: number;
  showOverlay: boolean;
  showAdminListsLoader: boolean;
  productList: PaypalProductModal[] = [];
  singleLicenseCost: number = 0;
  singleMasterCost: number = 0;
  filterLicense: number = 0;
  productNameSelected: string = '';
  mainViewError = new ErrorModel();
  searchError = new ErrorModel();
  emailError = new ErrorModel();
  qrCodeError = new ErrorModel();
  emailWait: boolean = true;
  qrLoader: boolean = true;
  currentSearchTerm: string = '';

  constructor(private service: LicenseDataService, private router: Router, private _route: ActivatedRoute, private location: Location) {}


  ngOnInit() {

    this.routingPath = '';
    this.filterLicense = 0;
    this.adminHaCount = 0;
    this.showbackDash = false;
    this.typeLicense = null;
    this.currentPage = 1;
    this.adminDetailData = new AdminData();
    this.userModel = new FormModel();
    this.emailIsValid = false;
    this.prodTypee = null;
    this._route.queryParams.subscribe(params => {
      this.filterLicense = params['filterLicense'], this.routingPath = params['routingPath']
    });
    if (this.routingPath == null || this.routingPath == undefined) {
      this.routingPath = '';
      this.showbackDash = false;
    } else {
      this.showbackDash = true;
    }
    if (this.filterLicense == undefined || this.filterLicense == null) {
      this.filterLicense = 0;
    }

    this.getAdmins();

  }

  getAdmins() {
    this.showOverlay = true;
    this.mainViewError.display = false;
    this.service.getAdmins(1, '', this.filterLicense).subscribe(
    (data) => {
      
      this.users = data['AdminLicenseDetails'];
      this.adminHaCount = data['HaAdminCount'];
      this.paypalProductModalFunction();
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlay = false;
    });

  }

  paypalProductModalFunction() {
    this.service.getProducts().subscribe(
    (data) => {
      this.productList = [];
      this.allProducts = data as PaypalProductModal[];
      this.productList = this.allProducts.filter(product => product.productType == (EProductType.MASTER as number));
      this.productList.forEach(i => {
        i.amount += this.allProducts.filter(product => product.productType == (EProductType.LICENSES as number))[0].amount;
      });
      this.singleLicenseCost = this.allProducts.filter(product => product.productType == (EProductType.LICENSES as number))[0].amount;
    });
  }


  onScrollGetAdmins() {
    this.showAdminListsLoader = true;
    this.currentPage = this.currentPage + 1;
    this.service.getAdmins(this.currentPage, this.currentSearchTerm, this.filterLicense).subscribe(
    (data) => {
      if (data['AdminLicenseDetails'].length == 0) {
        AlertMessages.Show('Done', 'Reached End of List', AlertType.Warning);
      }
      let admins: AdminData[] = data['AdminLicenseDetails']
      if (admins !== undefined) {
        admins.forEach(i => {
          this.users.push(i);
        });
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Cannot load Admins!', AlertType.Error);
    }).add(() => {
      this.showAdminListsLoader = false;
    });
  }

  searchUser(searchText: string) {
    this.currentSearchTerm = searchText;
    this.showAdminListsLoader = true;
    this.currentPage = 1;
    this.searchError.display = false;
    this.service.getAdmins(1, searchText.trim(), this.filterLicense).subscribe(
    (data) => {
      this.users = data['AdminLicenseDetails'];
    },
    (error) => {
      this.searchError.error = error;
      this.searchError.display = true;
    }).add(() => {
      this.showAdminListsLoader = false;
    });
  }

  // Go to details
  openDetails(adminId: string, licenseType) {
    this.router.navigate(['SA/Home/details'], {
      queryParams: {
        'Ad_Id': adminId,
        'lType':licenseType,
        'linkpath': this.showbackDash == true ? 'Dashboard>Admin>License' : 'Admin>License'
      }
    });
  }

  // edit item
  updateDetails(id) {
    this.productNameSelected = '';
    this.clicked = true;
    this.sButton = 'Update';
    this.users.filter(user => user.id == id).map((data) => {
      this.userModel.id = data.id;
      this.userModel.fullName = data.name;
      this.userModel.mobile = data.mobileNo;
      this.userModel.email = data.emailId;
      this.emailId = data.emailId;
      this.userModel.hospital = data.hospitalName;
      this.userModel.licenseType = data.licenseType;
      this.userModel.haLoginUsername = data.haLoginUsername;
      this.typeLicense = data.licenseType;
      this.userModel.licenseNumber = data.licenseNo;
      this.licenseNum = data.licenseNo;
      this.userModel.validDays = data.validDays;
      this.validDays = data.validDays;
      this.userModel.validDevices = data.validDevices;
      this.prodTypee = data.productId;
      this.productNameSelected = this.productList.filter(product => product.id == this.prodTypee)[0].productName;
      this.userModel.isPaymentPending = data.isPaymentPending;
      this.userModel.productType = this.productList.filter(product => product.id == data.productId)[0].productType;
      this.validDevices = data.validDevices;
      this.userModel.isUsed = data.isUsed;
      this.isUsed = data.isUsed;
      this.emailIsValid = true;
    });
  }

  emailCheck() {
    this.emailProcessing = true;
    this.service.checkEmailIsValid(this.emailId.toLowerCase(), this.userModel.id).subscribe(
    (result) => {
      this.emailReturn = result;
      this.emailProcessing = false;
      this.emailIsValid = this.emailReturn;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Cannot Check Email!', AlertType.Error);
    });
  }

  checkLicenseDays() {
    if (this.validDays < 1) {
      this.validDays = null;
    }
  }


  checkLicenseDevices() {
    if (this.validDevices < 1) {
      this.validDevices = null;
    }
  }

  reset() {

    this.userModel.id = null;
    this.userModel.fullName = '';
    this.userModel.mobile = '';
    this.userModel.email = '';
    this.userModel.hospital = '';
    this.userModel.licenseType = 0;
    this.userModel.licenseNumber = '0';
    this.userModel.validDays = 0;
    this.userModel.validDevices = 0;
    this.userModel.isUsed = false;
    this.userModel.productId = '';
    this.userModel.productType = null;
    this.productNameSelected = '';
    this.clicked = false;
    this.sButton = 'Save';
  }


  alertAdminClose() {
    setTimeout(() => {
      this.reset();
    }, 9000);
  }

  // submitting the form
  onSubmit(form: any) {

    this.adminDetailData = new AdminData();
    this.gettingFormValuesIntoModel(form);
    this.showAdminListsLoader = true;

 this.service.generateLicense(this.adminDetailData).subscribe((addedAdmin) => {

      // for alerting with message
      if (addedAdmin['SAID'] == null || addedAdmin['SAID'] == undefined || addedAdmin['SAID'] == '') {
        this.showAdminListsLoader = false;
      } else {
        if (this.adminDetailData.id == null || this.adminDetailData.id == '' || this.adminDetailData.id == undefined) {
          this.adminDetailData.id = addedAdmin['SAID'];
          this.adminDetailData.haLoginUsername = addedAdmin['TempUsername'];
          if (this.adminDetailData.id !== null && this.adminDetailData.id !== '' && this.adminDetailData.id !== undefined) {
            this.adminHaCount = this.adminHaCount + 1;
            this.alertAdminClose();
            AlertMessages.Show('Added', addedAdmin['StatusMessage'], AlertType.Add);
            this.adminDetailData.isUsed = false;
            this.adminDetailData.isPaymentPending = true;
            if (this.adminDetailData.licenseType == 2) {
              this.adminDetailData.tooltipFirstTime = true;
            } else {
              this.adminDetailData.tooltipFirstTime = false;
            }
            // TooltipFirstTime
            this.users.forEach(element => {
              element.tooltipFirstTime = false;
            });

            this.users.splice(0, 0, this.adminDetailData);
            this.showAdminListsLoader = false;
            form.reset();
            this.clicked = false;
            this.sButton = 'Save';
            this.adminDetailData = new AdminData();
            this.userModel = new FormModel();
          }

        } else {
          this.adminDetailData.haLoginUsername = addedAdmin['TempUsername'];
          let index = this.users.findIndex(user => user.id == addedAdmin['SAID']);
          this.users[index] = this.adminDetailData;
          AlertMessages.Show('UPDATED', this.adminDetailData.name + ' with license ' + this.adminDetailData.licenseNo + ' is updated', AlertType.Success);
          this.showAdminListsLoader = false;
          form.reset();
          this.clicked = false;
          this.sButton = 'Save';
          this.adminDetailData = new AdminData();
          this.userModel = new FormModel();
        }
        this.showAdminListsLoader = false;
      }
      this.showAdminListsLoader = false;
    },
    (error) => {
      AlertMessages.Show('Failed','Could not save user!',AlertType.Error);

    }).add(() => {
      this.showAdminListsLoader = false;
    });


  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  gettingFormValuesIntoModel(form: any) {
    this.adminDetailData.id = this.userModel.id;
    this.adminDetailData.isPaymentPending = this.userModel.isPaymentPending;
    this.adminDetailData.name = form.value.fullName;
    this.adminDetailData.hospitalName = form.value.hospital;
    this.adminDetailData.emailId = this.emailId.toLowerCase();
    this.adminDetailData.mobileNo = form.value.mobile;
    this.adminDetailData.licenseNo = form.value.licenseNumber;
    this.adminDetailData.licenseType = this.typeLicense;
    this.adminDetailData.validDays = this.validDays;
    this.adminDetailData.validDevices = this.validDevices;
    this.adminDetailData.isUsed = this.isUsed;
    this.adminDetailData.productId = this.prodTypee;
    this.adminDetailData.productType = this.productList.filter(product => product.id == this.prodTypee)[0].productType;
    this.adminDetailData.productName = this.productList.filter(product => product.id == this.prodTypee)[0].productName;
  }

  //delete license
  delete(id, user, adminForm) {
    this.reset();
    adminForm.reset();
    if (user.isUsed) {
      if (confirm('This Admin is Registered , Do you still want to delete !!')) {
        this.deleteHa(id);
      }
    } else {
      if (confirm('Do you want to delete this Admin')) {
        this.deleteHa(id);
      }
    }
  }

  deleteHa(Id) {
    this.service.deleteHAAdminLicense(Id).subscribe(
    (message) => {
      if (message['Id'] == 1) {
        let index = this.users.findIndex(user => user.id == Id);
        this.adminHaCount = this.adminHaCount - 1;
        this.adminDetailData = this.users[index];
        AlertMessages.Show('DELETED', this.adminDetailData.name + ' with license ' + this.adminDetailData.licenseNo + ' is deleted', AlertType.Success);
        this.users.splice(index, 1);
        this.adminDetailData = new AdminData();
      }
    },
    (error) => {
      AlertMessages.Show('Failed','Could not delete', AlertType.Error);
    });
  }

  resendMail(id) {
    this.credentialData = {};
    this.emailWait = true;
    this.emailError.display = false;
    this.userResendMail = new AdminData();
    this.userResendMail = this.users.filter(user => user.id == id)[0];
    this.mailIdToResend = '';
    this.mailIdToResend = this.userResendMail.emailId;
    this.showMail = true;
    this.service.getUserCredentials(id).subscribe(
    (data: any) => {
      this.credentialData = data;
      // $('#resendMail').modal('show');
    },
    (error) => {
      this.emailError.error = error;
      this.emailError.display = true;
    }).add(() => {
      this.emailWait = false;
    });

  }

  cancelResend() {
    this.showMail = false;
    this.mailIdToResend = '';
    $('#resendMail').modal('hide');

  }

  mailModalClick(form) {
    this.showMailLoad = true;
    let mailid = '';
    mailid = form.value.emaill;
    let Name = '';
    Name = this.credentialData.name;
    let Username = '';
    Username = this.credentialData.username;
    let Password = '';
    Password = this.credentialData.password;
    let IsUsed: boolean = false;
    IsUsed = this.credentialData.isUsed;
    this.service.resendMailToHa(this.userResendMail.id, mailid, Name, Username, Password, IsUsed).subscribe(
    (message: any) => {
      AlertMessages.Show('Message', 'Mail sent!', AlertType.Success);
    },
    (error) => {
      AlertMessages.Show('Failed','could not send mail', AlertType.Error);
    }).add(() => {
      this.alertCloseMail();
    });
  }

  alertCloseMail() {
      // $('#resendMail').modal('hide');
      this.showMail = false;
      this.showMailLoad = false;
      this.userResendMail = new AdminData();
  }

  // get Qr Codes
  getQrForAdmins(id: string) {
    this.qrLoader = true;
    this.qrCodeError.display = false;
    this.service.getQrInfo(id).subscribe(
    (data) => {
      this.qrInfo = data;
    },
    (error) => {
      this.qrCodeError.error = error;
      this.qrCodeError.display = true;
    }).add(() => {
      this.qrLoader = false;
    });
  }

  // to generate random license number
  makeRandomLicense() {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (let i = 0; i < 20; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    this.licenseNum = this.typeLicense == 1 ? ('DEMO' + text).substring(0, 20) : this.typeLicense == 2 ? ('REG' + text).substring(0, 20) : null;
    if (this.typeLicense == 2) {
      this.validDays = 30;
      this.validDaysReadOnly = true;
    } else {
      this.validDays = null;
      this.validDaysReadOnly = false;
    }
  }

  goBackDash() {
    this.location.back();
  }

  closeTooltip(userId) {
    this.users.filter(user => user.id == userId)[0].tooltipFirstTime = false;
  }

}
